var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2433 11.0002L11.2716 7.70725C11.6431 7.31625 11.6431 6.68425 11.2716 6.29325C10.9002 5.90225 10.2998 5.90225 9.92835 6.29325L5.27834 11.2933C4.90689 11.6842 4.90689 12.3163 5.27834 12.7073L9.92835 17.7072C10.1136 17.9022 10.3568 18.0002 10.6 18.0002C10.8432 18.0002 11.0864 17.9022 11.2716 17.7072C11.6431 17.3162 11.6431 16.6842 11.2716 16.2933L8.2433 13.0002H18.05C18.5754 13.0002 19 12.5522 19 12.0002C19 11.4482 18.5754 11.0002 18.05 11.0002H8.2433Z",
    fill: "#434856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.1619a4f99b9852681d5858eef9dee9d2.svg";
export { ForwardRef as ReactComponent };